import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { issueNavigatorProjectSoftwareCustomEmbedRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorProjectSoftwareCustomEmbedRoute.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';

import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { EmbedIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getCommonProjectResources } from './common/getCommonProjectResources.tsx';
import { issueNavigatorEmbedPageEntryPoint } from './ui/index.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import { ListRedirect } from './ui/list-redirect/ListRedirect.tsx';

/**
 * Software Project Issue Navigator Embed Route Entry
 * Handles Software projects.
 */
export const issueNavigatorProjectSoftwareCustomEmbedRouteEntry = createEntry(
	issueNavigatorProjectSoftwareCustomEmbedRoute,
	() => ({
		group: 'issue-navigator',

		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},

		skeleton: EmbedIssueNavigatorSkeleton,
		resources: [
			...getCommonProjectResources(),
			resourceWithCondition2(
				() => !fg('empanada_nin_resource_audit_2025_project_scope'),
				getConsolidationStateResource(),
			),
		],
		layout: chromelessLayout,

		component: fg('jira_list_nin_merge') ? ListRedirect : undefined,
		entryPoint: () => (fg('jira_list_nin_merge') ? undefined : issueNavigatorEmbedPageEntryPoint),
		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorProjectSoftwareCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorProjectSoftwareCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
